import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api, API_BASE } from "../api/client";

const BrandingContext = createContext({ branding: null });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);

  const reload = useCallback(
    () => api.get("/public/branding").then(({ data }) => setBranding(data.data)).catch((err) => console.error("branding load failed", err)),
    []
  );
  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    if (branding?.accent_color) document.documentElement.style.setProperty("--brand-accent", branding.accent_color);
  }, [branding?.accent_color]);

  const value = useMemo(() => ({ branding, reload }), [branding, reload]);

  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}

export function useBranding() {
  return useContext(BrandingContext);
}

export function logoUrl(fileId) {
  return `${API_BASE}/public/files/${fileId}`;
}

export function pickText(field, lang) {
  if (!field) return null;
  return (field[lang] || field.id || field.en || "").trim() || null;
}
